import { YOU_WERE_SUCCESSFULLY_LOGGED_IN_AS_username } from 'mk/autogenerated/translations/Login.sagas.4379fcb99fcaa71339ea0c0ea13ffbfa'
import { users_api_auth_login_url } from 'mk/urls/functions';
import * as homeUrls from 'mk2/apps/home/urls';
import { LOGIN_FORM_NAME } from 'mk2/apps/users/components/LoginForm';
import {
    LOGIN_TRIGGER,
    loginAPI,
    LoginNormalizedResponse,
    LoginTriggerAction,
} from 'mk2/apps/users/containers/Login/Login.actions';
import { gotoUrlAfterLoginOrSignup, storeLastKnownUsernameCookie } from 'mk2/apps/users/utils';
import { normalizeError, XHRAction, XHRFormError } from 'mk2/helpers/api';
import { handleXHRFormErrorSaga, handleXHRFormSuccessSaga } from 'mk2/helpers/form';
import { getLogger } from 'mk2/logger';
import { getRequestBaseUrl } from 'mk2/reducers';
import { UserEntity, UserSchema } from 'mk2/schemas';
import { getRoutingLocation } from 'mk2/selectors';
import { interpolate } from 'mk2/services/i18n';
import { normalize } from 'normalizr';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';

const logger = getLogger('users/Login.sagas');

interface ApiResponseLogin {
    body: {
        user: UserEntity;
    };
}

function* login({loginFd, xhr}: LoginTriggerAction & XHRAction) {
    yield put(loginAPI.request(loginFd));

    try {
        const response: ApiResponseLogin = yield call(
            () => xhr.post(users_api_auth_login_url(), {
                loginFd,
            }),
        );
        const normalizedResponse: LoginNormalizedResponse = normalize(response.body, {user: UserSchema});
        storeLastKnownUsernameCookie(response.body.user.username);

        const msg = interpolate(YOU_WERE_SUCCESSFULLY_LOGGED_IN_AS_username, {username: response.body.user.username});
        const baseUrl = yield select(getRequestBaseUrl);
        const location = yield select(getRoutingLocation);
        const gotoUrl = gotoUrlAfterLoginOrSignup(baseUrl, location, homeUrls.homepage);

        yield handleXHRFormSuccessSaga(LOGIN_FORM_NAME, gotoUrl, msg);
        yield put(loginAPI.success(loginFd, normalizedResponse));
    } catch (error) {
        yield handleXHRFormErrorSaga(LOGIN_FORM_NAME, error as XHRFormError, logger);
        yield put(loginAPI.failure(loginFd, normalizeError(error)));
    }
}

export default function* root() {
    yield all([
        takeLatest(LOGIN_TRIGGER, login),
    ]);
}
